module.exports = __webpack_public_path__ + "static/img/liantong@2x.4f3336e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partners/liantong@2x.png
// module id = ivou
// module chunks = 1